// extracted by mini-css-extract-plugin
module.exports = {"liveNow":"LiveNow_liveNow__YFZU_","blink":"LiveNow_blink___8Mav"};